import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EAxis } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useAxisSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.horizontal),
                value: EAxis.Horizontal,
            },
            {
                label: intl.formatMessage(message.vertical),
                value: EAxis.Vertical,
            },
        ],
        [intl],
    )
}
